import { useContext, useEffect } from "react";
import { Link, Outlet, useLocation, useSearchParams } from "react-router-dom";
import { Grid } from "@mui/material";
import { LocaleContext } from "../../routing/LangRouter";
import { useTranslation } from "react-i18next";
import { connect } from "react-redux";

import { saveHotelSelectedFilters } from "../../store/actions";

//import images and icons
import Icon from "../../components/common/base-icon/icon";

//import styles
import "./hotel.scss";

function Hotel({ dispatch }) {
    //general variable
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const { locale } = useContext(LocaleContext);
    const { t } = useTranslation();

    //sessionStorage variables
    const { isItinerary } = JSON.parse(sessionStorage.getItem("generalInformation")) || {};

    //tab list
    const tabList = [
        {
            title: `${t("domesticHotel")}`,
            type: "domestic",
            status: "enable",
            activeLink: `/${locale}/hotel-search/domestic` || `/${locale}/itinerary/hotel-search/domestic`,
            activeIcon: "HotelActiveIcon",
            inactiveIcon: "HotelInactiveIcon",
        },
        {
            title: `${t("internationalHotel")}`,
            type: "international",
            status: `${isItinerary ? "disable" : "enable"}`,
            activeLink: `/${locale}/hotel-search/international` || `/${locale}/itinerary/hotel-search/international`,
            activeIcon: "IntlHotelActiveIcon",
            inactiveIcon: "IntlHotelInactiveIcon",
        },
    ];

    useEffect(() => {
        const isHotelInternational = location.pathname.includes("/international");
        const updatedInfo = {
            isTicket: false,
            isAccommodation: true,
            isItinerary: false,
            isHotelInternational,
        };

        sessionStorage.setItem("generalInformation", JSON.stringify(updatedInfo));
    }, [location.pathname]);

    //handle links disable
    const handleDisable = event => {
        event.preventDefault();
    };

    useEffect(() => {
        const action = searchParams.get("action");
        if (searchParams.size > 0) {
            if (action !== "search") searchParams.delete("action");
            searchParams.delete("hotelId");
            setSearchParams(searchParams);
        }
    }, []);

    //handle filter cancellation
    const resetFilters = () => {
        dispatch(saveHotelSelectedFilters(null));
    };

    return (
        <Grid className="hotel" container>
            <Grid
                className="hotel__form"
                container
                item
                xs={12}
                rowGap={2.5}
                columnGap={1}
                justifyContent={{ xs: "space-between", md: "flex-start" }}
            >
                {tabList.map(tab => {
                    return (
                        <Grid key={Math.random()} container item xs={5.8} md={2} alignItems="center">
                            <Link
                                className={`hotel__tab ${tab.status} ${location.pathname === tab.activeLink ? "active" : ""}`}
                                to={tab.type}
                                onClick={tab.status === "disable" ? handleDisable : resetFilters}
                            >
                                <Icon
                                    name={location.pathname === tab.activeLink ? tab.activeIcon : tab.inactiveIcon}
                                    style={{ margin: "0 0.5rem" }}
                                />
                                {tab.title}
                                {tab.status === "disable" ? `(${t("soon")})` : ""}
                            </Link>
                        </Grid>
                    );
                })}
                <Outlet />
            </Grid>
        </Grid>
    );
}

export default connect()(Hotel);
